import React from 'react';
import PropTypes from 'prop-types';
import './backdrop.scss';
import clsx from 'clsx';

const Backdrop = ({
  open, drawer, onBackdropClick, children, className,
}) => {
  const handleOnClick = (event) => {
    if (onBackdropClick && (event.target === event.currentTarget)) {
      onBackdropClick.call(null);
    }
  };

  return (
    <div className={clsx('backdrop-cont', className, { open, drawer })} onClick={handleOnClick}>
      {open ? children : null}
    </div>
  );
};

Backdrop.propTypes = {
  open: PropTypes.bool,
  onBackdropClick: PropTypes.func,
  children: PropTypes.node,
  drawer: PropTypes.bool,
  className: PropTypes.string,
};

Backdrop.defaultProps = {
  open: false,
  onBackdropClick: () => {},
  children: null,
  drawer: false,
  className: '',
};

export default Backdrop;
